import { Injectable, Optional } from '@angular/core';
import { INDDI18nServiceConfigResources, NDDI18nServiceConfigResources, NDDTranslationResourceService } from '@ndk/ng-translation';

/**
 * Interface com atributos necessários para configuração i18n.
 *
 * @export
 * @interface INDDSettingsI18nServiceConfigResources
 * @extends {INDDI18nServiceConfigResources}
 */
export interface INDDSettingsI18nServiceConfigResources extends INDDI18nServiceConfigResources {
    btnEdit?: string;
}

/**
 * Configurações i18n gerais do módulo.
 *
 * @export
 * @class NDDSettingsI18nServiceConfig
 * @implements {NDDI18nServiceConfigResources}
 */
export class NDDSettingsI18nServiceConfig implements NDDI18nServiceConfigResources {
    public i18n: boolean;
    public resources: INDDSettingsI18nServiceConfigResources = {
        btnEdit: 'Editar',
    };
}

@Injectable()
/** Serviço de configuração i18n. */
export class NDDSettingsI18nService extends NDDTranslationResourceService {
    constructor(@Optional() config: NDDSettingsI18nServiceConfig) {
        super(config, new NDDSettingsI18nServiceConfig());
    }
}
